import { useState } from 'react';
import { useLocation } from 'react-router';
import { Box, Button, Card, Collapsible, Separator, Text, Timeline } from '@chakra-ui/react';
import { PiCaretDownBold, PiCaretUpBold } from 'react-icons/pi';
import { formatDate } from '@utils/date';
import { formatMoney } from '@utils/formats';

import type { DispositionType } from '../types';

const TimelineItem = ({ disposition }: { disposition: DispositionType }) => {
  const [showFullContent, setShowFullContent] = useState(false);

  const isBigContent = disposition.outcome?.length > 100;

  const shortContent = isBigContent
    ? `${disposition.outcome.substring(0, 100)}...`
    : disposition.outcome;

  const content = showFullContent ? disposition.outcome : shortContent;

  return (
    <Timeline.Item>
      <Timeline.Connector>
        <Timeline.Separator />
        <Timeline.Indicator />
      </Timeline.Connector>
      <Timeline.Content>
        <Timeline.Title>{disposition.outcome_option.name}</Timeline.Title>
        <Timeline.Description>
          {disposition.user.name}
          {' '}
          em
          {' '}
          {formatDate(disposition.execution_date, "dd/MM/yyyy 'às' HH:mm'h'")}
        </Timeline.Description>
        {disposition?.attributes?.negotiated_value && (
          <Text textStyle="sm">
            Valor negociado:
            {' '}
            <b>
              {formatMoney(disposition.attributes?.negotiated_value)}
            </b>
          </Text>
        )}
        <Text textStyle="sm">
          {disposition.outcome ? content : 'Sem comentários'}
          {' '}
          {!showFullContent && isBigContent && (
            <Text as="span" fontWeight={600} onClick={() => setShowFullContent(true)}>
              Ver mais
            </Text>
          )}
        </Text>
        {showFullContent && (
          <Button
            variant="ghost"
            size="xs"
            width="60px"
            height="16px"
            p={0}
            onClick={() => setShowFullContent(false)}
          >
            Ver menos
          </Button>
        )}
      </Timeline.Content>
    </Timeline.Item>
  );
};

const DispositionHistory = () => {
  const location = useLocation();
  const dispositions: DispositionType[] = location.state.dispositions || [];

  const [showContent, setShowContent] = useState(true);

  return (
    <Card.Root
      size="sm"
      variant="subtle"
      p={4}
      mb={5}
    >
      <Collapsible.Root open={showContent} onOpenChange={(e) => setShowContent(e.open)}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Text fontSize="md" fontWeight="bold">
            Histórico de tabulações
          </Text>
          <Collapsible.Trigger p={2} cursor="pointer">
            {showContent ? <PiCaretUpBold /> : <PiCaretDownBold />}
          </Collapsible.Trigger>
        </Box>

        <Collapsible.Content>
          <Separator mb={6} mt={1} />
          <Timeline.Root>
            {dispositions.map((disposition, index) => (
              <TimelineItem key={index} disposition={disposition} />
            ))}
          </Timeline.Root>
        </Collapsible.Content>
      </Collapsible.Root>
    </Card.Root>
  );
};

export default DispositionHistory;
